import React from 'react';
import { RouteComponentProps, Switch, Route, Redirect } from 'react-router-dom';
import { CenteredLayout, ResponsiveContainer, useObservable } from '@lib/common';
import { sessionQuery } from '@lib/state';
import { ClaimReservationPage, CreateReservationPage, VerifyReservationCodePage } from './pages';
import { ReservationAccountPage } from './pages/reservation-account.page';

export const ReservationRoutes: React.FC<RouteComponentProps> = ({ location }) => {
  const isLoggedIn = useObservable(sessionQuery.isLoggedIn, 'async');
  return (
    <Switch>
      <Route path="/" exact component={CreateReservationPage} />
      {/* Require sign-in to proceed with the claim process */}
      {!isLoggedIn && (
        <Redirect
          to={{
            pathname: '/account/signin',
            search: `redirect=${location.pathname}${location.search}`,
          }}
        />
      )}
      <CenteredLayout>
        <ResponsiveContainer>
          <Switch>
            <Route
              path={`/reservations/:reservationId/verify`}
              component={VerifyReservationCodePage}
            />
            <Route
              path={`/reservations/:reservationId/account`}
              component={ReservationAccountPage}
            />
            <Route path={`/reservations/:reservationId/claim`} component={ClaimReservationPage} />
            <Redirect to="/" />
          </Switch>
        </ResponsiveContainer>
      </CenteredLayout>
    </Switch>
  );
};
